// Vue mixin for globally applied loading indication and error display with VueAxios
import {EventBus} from "../EventBus";
import shared from "../util/shared";

export default  {
    data: function () {
        return {
            loading: 0,
            loadingImage: '/images/ripple.60px.svg',
            errorBag: [],
            Shared: shared,
            errorToast: {
                title: 'Error',
                subtitle: 'Bad response',
                delay: 10000,
                autohide: true,
                class: 'fas fa-exclamation-triangle',
            },
            preloader: null,
        }
    },
    created: function () {
        this.axios.interceptors.request.use((config) => {
            this.loading += 1;
            return config;
        }, (error) => {
            console.log(`Request error: ${error}`);
            let errorMessage = this.Shared.errorHandlerForResponder(error);
            this.errorBag.push(errorMessage);
            this.Shared.forceModal(error) ? this.modalErrorOpen(errorMessage) : this.errorToastOpen(errorMessage);

            this.loading -= 1;
            return Promise.reject(error);
        });

        this.axios.interceptors.response.use((response) => {
            this.loading -= 1;
            return response;
        }, (error) => {
            console.log(`Response error: ${error}`);
            let errorMessage = this.Shared.errorHandlerForResponder(error);
            this.errorBag.push(errorMessage);
            this.Shared.forceModal(error) ? this.modalErrorOpen(errorMessage) : this.errorToastOpen(errorMessage);

            this.loading -= 1;
            return Promise.reject(error);
        });

        console.log(`Loaded mixin LoadingInjector`);
    },
    mounted: function () {
        this.preloader = jQuery('#preloader');
    },
    methods: {
        errorToastOpen: function (message) {
            jQuery(document).Toasts('create', {
                title: this.errorToast.title,
                subtitle: `&nbsp;${this.errorToast.subtitle}`,
                position: 'topRight',
                class: 'bg-danger',
                icon: this.errorToast.class,
                body: message,
                autohide: this.errorToast.autohide,
                delay: this.errorToast.delay
            });
        },
        modalErrorOpen: function (message, title=null) {
            try {
                EventBus.$emit('modalErrorContentChanged', {message, title});
            } catch (e) {
                console.log(e);
            }

            this.$bvModal.show('modalError');
        }
    },
    watch: {
        loading: function () {
            if (this.loading > 0) {
                this.preloader.css('display', 'flex');
            } else {
                this.preloader.css('display', 'none');
            }
        }
    }
};

